import * as React from "react";

const HideMainNav: React.FC = () => {
  return <style>{"header {display: none !important}"}</style>;
};

export default HideMainNav;
